import { render, staticRenderFns } from "./CurFnbOwner.vue?vue&type=template&id=1b719522&"
import script from "./CurFnbOwner.vue?vue&type=script&lang=ts&"
export * from "./CurFnbOwner.vue?vue&type=script&lang=ts&"
import style0 from "./CurFnbOwner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports